import { WmOption, WmSelect } from "@watermarkinsights/ripple-react";
import { useIntl } from "react-intl";
import { formatDate } from "../common/helper";
import { Term } from "../common/interfaces/Interface";

export interface TermsProps {
  terms: Term[];
  selectedTerm: Term;
  selectTerm: (term: Term) => void;
}
const Terms = ({ terms, selectedTerm, selectTerm }: TermsProps) => {
  const termLabel = useIntl().formatMessage({
    id: "app.sse.termLabel"
  });

  return (
    <div className="reporting-year-width">
      <WmSelect label={termLabel} labelPosition="left" id="select-terms">
        {terms.map((term: Term) => {
          return (
            <WmOption
              id={`terms-${term.uuid}`}
              key={`terms-${term.uuid}`}
              selected={selectedTerm?.uuid === term.uuid}
              onClick={() => selectTerm(term)}
            >
              {term.name}
            </WmOption>
          );
        })}
      </WmSelect>
      {selectedTerm && (
        <div className="reporting-year-duration">
          {`${formatDate(selectedTerm?.startDate)} - ${formatDate(
            selectedTerm?.endDate
          )}`}
        </div>
      )}
    </div>
  );
};

export default Terms;
